import React from 'react';
import Spinner from '../Spinner';
import './styles.scss';

const AppLoading = ({ loading, children }) => {
  return (
    <>
      {loading ? (
        <div className="loading-modal">
          <div className="loading-container">
            <Spinner />
          </div>
        </div>
      ) : (
        children
      )}
    </>
  );
};

export default AppLoading;
